import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { useTWGrowthBook } from 'tradera/hooks/use-tw-growth-book';
import type { InitData } from 'tradera/state/init-data/types';

type WithGrowthBookProps = {
    initData: InitData;
    children: React.ReactNode;
};

export const WithGrowthBook = ({ initData, children }: WithGrowthBookProps) => {
    const growthbook = useTWGrowthBook(initData);
    return growthbook ? (
        <GrowthBookProvider growthbook={growthbook}>
            {children}
        </GrowthBookProvider>
    ) : (
        children
    );
};
